import { render, staticRenderFns } from "./ReceiptInputForm.vue?vue&type=template&id=64203294&scoped=true&"
import script from "./ReceiptInputForm.vue?vue&type=script&lang=js&"
export * from "./ReceiptInputForm.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptInputForm.vue?vue&type=style&index=0&id=64203294&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64203294",
  null
  
)

export default component.exports